import React from 'react'
import { NextPage, NextPageContext } from 'next'
import Error from '../../_error'
import { InvestorTemplate } from '@/components/pages/investor/InvestorTemplate'
import { PaginationFromPageInfo } from '@/components/common/PaginationFromPageInfo'
import { InvestorFinanceNewsList } from '@/components/pages/investor/InvestorFinanceNewsList'
import { getFinanceNews, fetchInvestorSummary } from '@/lib/api/investor'
import { pageFromQuery } from '@/lib/page'
import {
  InvestorFinanceNews,
  InvestorSummary,
  PageApiRespone,
} from '../../../types'

type Props = {
  summary: InvestorSummary | undefined
  news: PageApiRespone<InvestorFinanceNews[]>
}

const FinanceNewsPage: NextPage<Props> = (props) => {
  if (!props.summary) {
    return <Error />
  }

  return (
    <InvestorTemplate summary={props.summary} tab="news">
      <InvestorFinanceNewsList list={props.news.data} />
      <PaginationFromPageInfo
        link={{
          href: `/investor/finance-news?shortname=${props.summary.shortname}`,
          as: `/investors/${props.summary.shortname}/finance-news`,
        }}
        limit={props.news.limit}
        offset={props.news.offset}
        count={props.news.count}
      />
    </InvestorTemplate>
  )
}

FinanceNewsPage.getInitialProps = async (ctx: NextPageContext) => {
  const shortname = ctx.query.shortname!.toString()
  const { limit, offset } = pageFromQuery(ctx.query)
  const investorSummaryResponse = await fetchInvestorSummary(ctx, shortname)

  const [summary, news] = await Promise.all([
    investorSummaryResponse?.data,
    getFinanceNews(shortname, limit, offset),
  ])

  return { summary, news }
}

export default FinanceNewsPage
